var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-navbar-msg",on:{"click":_vm.message}},[_c('i',{staticClass:"iconfont icon-xiaoxixinxihuihuahuida"}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.has_red_point > 0),expression:"has_red_point > 0"}],staticClass:"redPointMessage"})])
}
var staticRenderFns = []

export { render, staticRenderFns }